import type { IWalletConnectionStore } from "@/domains/wallet/types"

import type { IAddressSource } from "./interfaces"
import type { ManagerStore } from "./manager-store"

/**
 * Address source that uses the selected manager address if set,
 * otherwise falls back to the connected wallet address.
 * Used by the Manager Lock orchestrator.
 */
export class ManagerAddressSource implements IAddressSource {
  constructor(
    private readonly managerStore: ManagerStore,
    private readonly walletStore: IWalletConnectionStore,
  ) {}

  getCurrentAddress() {
    // If a manager address is selected, use it
    if (this.managerStore.selectedManagerAddress) {
      return this.managerStore.selectedManagerAddress
    }

    // Otherwise, fall back to connected wallet address
    return this.walletStore.connectedAddress ?? null
  }
}
